// extracted by mini-css-extract-plugin
export default {"main":"Empty_main__hcpfP","message":"Empty_message__e5erl","contact-btn":"Empty_contact-btn__Tqb16"};